<mat-checkbox
  [checked]="checked"
  (change)="onChange($event)"
  value="{{value}}"
  [disabled]="disabled"
>{{ text }}</mat-checkbox>
